import * as React from 'react';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const updatePopup = (props: any) => {
    const { open, closePopup, title, message, onUpdate } = props;
    return (<>
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modelChat"
            open={open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div className="dispachModeldiv p-0 col-md-4">
                    <div className="d-flex justify-content-between backgroundcolorTheme1 p-2">
                        <h5 className="fw-bold mt-1 colorWhite">{title}</h5>
                        <div>
                            <HighlightOffIcon
                                fontSize="large"
                                className="cursor colorWhite"
                                onClick={closePopup}
                            />{" "}
                        </div>
                    </div>

                    <div className="p-3 text-center font18">
                        {message}
                        <div className='deleteActionButtons mt-4'>
                            <button
                                className="btn addMoreBtn me-2 px-4"
                                onClick={() => {
                                    onUpdate();
                                    closePopup();
                                }}
                            >
                                Yes
                            </button>
                            <button
                                className="btn btn-secondary px-4"
                                onClick={closePopup}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    </>);
}

export default updatePopup;